export const en = {
    'default-header-description': 'Internal advertising products',
    'default-title': 'Products',
    description: 'Description of the product list (ask editor)',
    'error-text': 'Try refreshing the page',
    'error-title': 'Something went wrong',
    loading: 'Loading...',
    'marketers-header-description': 'Manage internal advertising products',
    'marketers-title': 'Manage products',
    title: 'Product list'
};
